
import React from 'react';
import { Crosshair, CircleCheckBig } from 'lucide-react';
import TaskSectionSkeleton from './TaskSectionSkeleton';

interface TaskBoardSkeletonProps {
  activeTaskCount?: number;
  completedTaskCount?: number;
  showCompletedExpanded?: boolean;
}

const TaskBoardSkeleton: React.FC<TaskBoardSkeletonProps> = ({
  activeTaskCount = 3,
  completedTaskCount = 2,
  showCompletedExpanded = false
}) => {
  return (
    <div className="space-y-6">
      {/* Active Tasks Section */}
      <TaskSectionSkeleton
        title="Active Tasks"
        icon={<Crosshair className="text-amber-500 dark:text-amber-400" size={18} />}
        variant="amber"
        cardCount={activeTaskCount}
        index={0}
      />

      {/* Completed Tasks Section */}
      <TaskSectionSkeleton
        title="Completed Tasks"
        icon={<CircleCheckBig className="text-green-500 dark:text-green-400" size={18} />}
        variant="green"
        cardCount={completedTaskCount}
        showExpanded={showCompletedExpanded}
        index={1}
      />
    </div>
  );
};

export default TaskBoardSkeleton;
